import './orderHistoryComponent.css'

import { Col, Container, Row, Spinner, Table } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import { useUserShippedPackages } from '../../../api/user-package/hooks/useUserShippedPackages'
import exelotLogo from '../../../imgs/exelot-logo.png'
import greeceFlagCircle from '../../../imgs/flags/greece-circle.png'
import turkeyFlagCircle from '../../../imgs/flags/turkey-circle.png'
import ukFlagCircle from '../../../imgs/flags/uk-circle.png'
import usaFlagCircle from '../../../imgs/flags/usa-circle.png'
import noPackages from '../../../imgs/shopping-bag.jpg'
import { setPackageForPackageDetails } from '../../../store/packageSlice'
export default function OrderHistoryComponent() {
  const { data: shippedPackages } = useUserShippedPackages()
  const dispatch = useDispatch()
  const history = useHistory()

  const getCountryFlag = country => {
    switch (country) {
      case 'TR':
      case '':
      case 'a':
      case 'b':
        return turkeyFlagCircle
      case 'GR':
        return greeceFlagCircle
      case 'USA':
        return usaFlagCircle
      case 'UK':
        return ukFlagCircle
    }
  }

  const navigateToPackageDetails = item => {
    dispatch(setPackageForPackageDetails(item))
    history.push('/package-details')
  }

  return (
    <div className='rtlText'>
      <Container>
        <Row>
          <Col>
            <h4
              style={{
                textAlign: 'center',
                marginTop: '20px',
                fontWeight: 'bolder',
                marginBottom: '1rem',
              }}
            >
              חבילות שנשלחו
            </h4>
          </Col>
        </Row>
      </Container>
      {!shippedPackages ? (
        <div className='spinner-cont1'>
          <Spinner animation='border' variant='primary'></Spinner>
        </div>
      ) : (
        <>
          {shippedPackages.length === 0 ? (
            <div className='no-packages'>
              <div>אין חבילות עדיין...</div>
              <img src={noPackages} alt='shopping time' />
              <div>זמן טוב לשופינג!</div>
            </div>
          ) : (
            <Container className='containerForTable'>
              <Table className='tableForPackagePage marginTop0' responsive='sm'>
                <thead style={{ backgroundColor: '#00aeef', color: 'white' }}>
                  <tr>
                    <th> </th>
                    <th>שם החנות</th>
                    <th> תאריך יציאת החבילה ממחסננו </th>
                    <th> סוג משלוח </th>
                    <th> מספר מעקב</th>
                    {/* <th>מידות</th> */}
                  </tr>
                </thead>

                <tbody>
                  {shippedPackages.length > 0 ? (
                    shippedPackages.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td onClick={() => navigateToPackageDetails(item)}>
                            <img src={getCountryFlag(item.warehouse)} alt={item.warehouse} className='p-history-flag' />
                          </td>
                          <td onClick={() => navigateToPackageDetails(item)}>{item.brand}</td>
                          <td dir='ltr' onClick={() => navigateToPackageDetails(item)}>
                            {item ? item.updatedAt?.split('T')[0].split('-').reverse().join('.') : null}{' '}
                          </td>
                          <td onClick={() => navigateToPackageDetails(item)}>
                            {
                              {
                                pickUpPoint: 'נקודת חלוקה',
                                doorToDoor: 'עד הבית',
                              }[item.shippingMethod]
                            }
                          </td>
                          <td>
                            <Link
                              to={{
                                pathname: `https://public.exelot.com/tracking/${item.trackingNumberToIsrael}?lang=he`,
                              }}
                              target='_blank'
                            >
                              {item.trackingNumberToIsrael}
                            </Link>
                          </td>
                          {/* <td>
                        {item.length}x{item.height}x{item.width}, {item.weight}
                        KG{' '}
                      </td> */}
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td
                        style={{
                          textAlign: 'center',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        אין חבילות שנשלחו
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <div className='history-exelot'>
                <a
                  href='https://www.exelot.com/he/%d7%9e%d7%a2%d7%a7%d7%91-%d7%9e%d7%a9%d7%9c%d7%95%d7%97%d7%99%d7%9d/'
                  target='_blank'
                  rel='noreferrer'
                >
                  <img src={exelotLogo} />
                  <div className='btn yellow-bcg'>מעקב משלוחים Exelot</div>
                </a>
              </div>
            </Container>
          )}
        </>
      )}
    </div>
  )
}
